'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _DeliverySearchContainer = require('../../DeliverySearch/DeliverySearchContainer');

var _DeliverySearchContainer2 = _interopRequireDefault(_DeliverySearchContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PropTypes = require('prop-types');
var React = require('react');
var createReactClass = require('create-react-class');
var _ = require('lodash');
var MapCanvas = require('./MapCanvas.js');
var CheckboxContent = require('../CheckboxContent.js');
var SearchResult = require('./SearchResult.js');
var LocalizeMixin = require('../../../localization/CommonLocalizationMixin');
var SelectedResultModal = require('./SelectedResultModal.js');
var ListenerMixin = require('../../../mixins/ListenerMixin');
var AnalyticsConstants = require('../../../lib/analytics/Constants');
var accessibilityHelper = require('../../../lib/ADAHelpers');
var PageTitle = require('../../pageTitle').default;


var SearchContainer = createReactClass({
    displayName: 'SearchContainer',
    mixins: [LocalizeMixin, ListenerMixin],

    propTypes: {
        handleCancelClick: PropTypes.func
    },

    getDefaultProps: function getDefaultProps() {
        return {
            initialFilters: []
        };
    },

    getInitialState: function getInitialState() {
        return {
            filterShowing: false,
            mapShowing: false,
            selectedLocationId: false,
            inputVal: '',
            filters: this.props.initialFilters,
            dontRenderModal: false,
            url: this.determineStoreURL(),
            noMobileLocations: false,
            locationSelectedWithEnter: false
        };
    },

    determineStoreURL: function determineStoreURL() {
        var isMobile = {
            Android: function Android() {
                return window.navigator.userAgent.match(/Android/i) ? 'android' : '';
            },
            iOS: function iOS() {
                return window.navigator.userAgent.match(/iPhone|iPad|iPod/i) ? 'ios' : '';
            },
            any: function any() {
                return isMobile.Android() || isMobile.iOS();
            }
        };

        var Config = require('../../../lib/config');
        switch (isMobile.any()) {
            case 'android':
                {
                    return Config.urls.androidWendys;
                }
            case 'ios':
                {
                    return Config.urls.iosWendys;
                }
            default:
                {
                    return Config.urls.appWendys[this.props.lang + '_' + this.props.cntry] || Config.urls.appWendys.en_US;
                }
        }
    },

    locationSelectHandler: function locationSelectHandler(e) {
        if (e.type === 'order') {
            this.props.orderButtonClick(e.location);
        } else if (e.type === 'notify') {
            this.props.notifyClick(e.location);
        }
    },

    setInputValue: function setInputValue(e, deliveredFromClick) {
        var value = typeof e === 'string' ? e : e.target.value || '';

        this.setState({
            inputVal: value
        });
        if (deliveredFromClick) {
            this.handleSearchButtonClick(e);
        }

        if (this.props.notifyWhenChanged) {
            this.props.notifyWhenChanged();
        }
    },

    clearFilters: function clearFilters() {
        var self = this;
        console.log("self.state:", self.state, " clearing filters now");
        self.setState({
            filters: []
        });
    },

    getFilteredLocations: function getFilteredLocations(locationsFromProps, favoriteLocationIdsFromProps) {
        var self = this;
        if (locationsFromProps) {
            var locationsToReturn = _.filter(locationsFromProps, function (Location) {
                var valid = true;
                self.state.filters.forEach(function (filter) {
                    //for every filter
                    if (!Location[filter]) {
                        //filter on location is false valid is false
                        valid = false;
                    }
                    if (filter == "isFavorite") {
                        //fav is special because its stored in another service
                        //even if location is false for other filters if
                        //filter of is favorite is on, return location if id matches favIds
                        //only runs if looking for favorites to show, not perfomant for insane numbers of favorites
                        favoriteLocationIdsFromProps.forEach(function (favLocationId) {
                            if (Location.id == favLocationId) {
                                valid = true;
                            }
                        });
                    }
                });
                if (valid) {
                    return Location;
                }
                return false;
            });

            return locationsToReturn;
        } else {
            return [];
        }
    },

    checkboxHandler: function checkboxHandler(item) {
        var self = this;

        var filters = _.cloneDeep(this.state.filters);

        if (filters.indexOf(item) > -1) {
            filters.splice(filters.indexOf(item), 1);
        } else {
            filters.push(item);
        }

        this.setState({
            filters: filters,
            noMobileLocations: false
        }, function () {
            //no active flag (prevents never being able to check mobile order), its the only filter, and no filtered locations exist because of it
            if (self.state.noMobileLocations == false && filters[0] == 'hasMobileOrder' && filters.length < 2 && !self.getFilteredLocations(self.props.locations, self.props.favoriteLocationIds).length) {
                _.pull(filters, 'hasMobileOrder');
                self.setState({
                    noMobileLocations: true,
                    filters: filters
                });
            }
            this.handleSearchOnFilterChange();
        });
    },

    handleSearchOnFilterChange: function handleSearchOnFilterChange() {
        var filters = {};
        this.state.filters.map(function (filter) {
            filters[filter] = true;
        });
        if (this.props.handleSearchOnFilterChange) {
            this.props.handleSearchOnFilterChange(this.state.inputVal, filters);
        }
    },

    render: function render() {
        var locations = this.getFilteredLocations(this.props.locations, this.props.favoriteLocationIds);
        var mapStyle = this.state.mapShowing ? '' : ' hidden-xs';
        var listStyle = !this.state.mapShowing ? '' : ' hidden-xs';
        var searchResults = [];
        var self = this;
        var selectedLocationElement = [];

        locations.forEach(function (el, idx) {
            var selected = el.id == self.state.selectedLocationId;
            var isFavorite = _.includes(self.props.favoriteLocationIds, el.id);

            var component = React.createElement(SearchResult, _extends({}, self.props, {
                key: "search_result_" + el.id,
                isFavorite: isFavorite,
                favoriteLocationClick: self.props.favoriteLocationClick,
                searchResultPinClick: self.handleLocationSelect,
                selectedResult: selected,
                orderButtonClick: self.props.orderButtonClick,
                buttonType: 'ordering',
                id: el.id,
                location: el,
                notifyClick: self.props.notifyClick,
                noMobileLocations: self.state.noMobileLocations
            }));

            searchResults.push(component);

            if (selected) {
                selectedLocationElement.push(component);
            } else {
                selectedLocationElement.push('');
            }
        });

        //will only show if mobile order filter is the only one checked, there are locations, but there are non when mobile order filer is checked
        var noLocationsElement = '';
        var reducedHeightClass = '';
        if (!self.props.searchIsLoading) {
            //mobile flag active and only the mobile filter active
            if (self.state.noMobileLocations && (!this.state.filters.length || locations.length)) {
                reducedHeightClass = ' reduced-height';
                noLocationsElement = React.createElement(
                    'div',
                    { className: 'no-mobile' },
                    React.createElement(
                        'div',
                        { className: 'radius-and-shadow' },
                        React.createElement(
                            'div',
                            { className: 'bg-img' },
                            React.createElement(
                                'div',
                                { className: 'col-xs-8 col-sm-8 col-lg-8' },
                                React.createElement(
                                    'h1',
                                    null,
                                    this.getLocalizedText('search_results_on_our_way')
                                )
                            ),
                            React.createElement(
                                'div',
                                { className: 'col-xs-3 col-xs-offset-1 col-sm-4 col-sm-offset-0' },
                                React.createElement('img', { src: '/images/common/icons/ic_pin_red.png', alt: '', role: 'icon' })
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'secondary' },
                            React.createElement(
                                'p',
                                null,
                                this.getLocalizedText('search_results_no_mobile_desc')
                            )
                        )
                    )
                );
                //no locations and filters active (no mobile flag can't be active because prior if)
            } else if (!locations.length && !this.state.filters.length) {
                noLocationsElement = React.createElement(
                    'div',
                    { className: 'no-locations' },
                    React.createElement(
                        'div',
                        { className: 'col-xs-12 image' },
                        React.createElement('img', { src: '/images/img_loc_pin.png', alt: '', role: 'icon' })
                    ),
                    React.createElement(
                        'div',
                        { className: 'col-xs-12 text' },
                        React.createElement(
                            'p',
                            null,
                            this.getLocalizedText('search_results_no_loc')
                        )
                    )
                );

                //no locations (no filters as covered by above)
            } else if (!locations.length) {
                noLocationsElement = React.createElement(
                    'div',
                    { className: 'no-locations' },
                    React.createElement(
                        'div',
                        { className: 'col-xs-12 image' },
                        React.createElement('img', { src: '/images/img_loc_pin.png', alt: '', role: 'icon' })
                    ),
                    React.createElement(
                        'div',
                        { className: 'col-xs-12 text' },
                        React.createElement(
                            'p',
                            null,
                            this.getLocalizedText('search_results_too_many_filters')
                        )
                    )
                );
            }
        }

        var locationButton = this.props.showLocationButton ? React.createElement(
            'div',
            { className: this.props.searchIsLoading ? "my-location add-opacity" : "my-location", onKeyUp: accessibilityHelper.keyupHandler,
                onClick: this.props.searchIsLoading ? '' : this.handleMyLocationClick, tabIndex: '0',
                'aria-label': this.getLocalizedText('ada_find_search_your_location'), role: 'button' },
            React.createElement('img', { src: '/images/common/icons/location.png' })
        ) : '';

        var suggestedLocations = this.props.suggestedLocations || [];
        var suggestedLocationBox = React.createElement(
            'ul',
            { className: 'suggested-locations-dropdown', 'aria-live': 'assertive', 'aria-atomic': 'true', role: 'listbox' },
            suggestedLocations.length > 0 && React.createElement(
                'div',
                { className: 'desc' },
                this.getLocalizedText('search_container_no_results_message')
            ),
            suggestedLocations.slice(0, 5).map(function (loc, i) {
                return React.createElement(
                    'li',
                    { key: loc.lat + loc.lng + loc.address1 + loc.address2, className: 'suggested-location-option',
                        onClick: self.setInputValue.bind(null, loc.address2, true), onKeyDown: self.handleSuggestedLocationKeyDown,
                        role: 'option', tabIndex: '0', 'aria-setsize': suggestedLocations.slice(0, 5).length, 'aria-posinset': i + 1 },
                    loc.address1,
                    ' ',
                    loc.address2
                );
            })
        );

        var loadingSpinner = this.props.searchIsLoading ? React.createElement('img', { className: 'loading-gif', src: '/images/common/ajax-loader.gif' }) : '';
        var smallifyClass = this.props.lang == 'fr' ? 'smallify-search-text' : '';
        var searchButtonClasses = this.props.searchIsLoading ? "btn btn-primary add-opacity" : "btn btn-primary";

        var FPOContent = this.props.app === 'find' ? React.createElement(_DeliverySearchContainer2.default, {
            Store: this.props.Store,
            Actions: this.props.Actions,
            lang: this.props.lang,
            cntry: this.props.cntry,
            googleMapsHelper: this.props.googleMapsHelper
        }) : React.createElement(
            'a',
            { href: this.state.url, tabIndex: '-1' },
            React.createElement('img', { src: '/images/common/promo-images/285x264_location.jpg', id: 'location-promo-small' }),
            React.createElement('img', { src: '/images/common/promo-images/374x227_location.jpg', id: 'location-promo-medium' }),
            React.createElement('img', { src: '/images/common/promo-images/458x227_location.jpg', id: 'location-promo-large' })
        );

        return React.createElement(
            'div',
            { className: 'search-container' },
            React.createElement(
                'div',
                { style: { fontSize: 0 }, 'aria-live': 'assertive', 'aria-atomic': 'true' },
                this.props.searchIsLoading && this.getLocalizedText('search_container_searching'),
                searchResults.length > 0 && !this.props.searchIsLoading && suggestedLocations.length === 0 && searchResults.length + ' ' + this.getLocalizedText('search_container_results_found')
            ),
            React.createElement(
                'div',
                { className: 'map-container' },
                React.createElement(PageTitle, { imgAltText: this.getLocalizedText('ada_cancel'),
                    locationCancelHandler: this.props.handleCancelClick ? this.props.handleCancelClick : '',
                    titleText: this.getLocalizedText('location_page_find_location_title') }),
                React.createElement(
                    'div',
                    { className: 'search-options-container' },
                    React.createElement(
                        'div',
                        { className: 'search-and-filters' },
                        React.createElement(
                            'div',
                            { className: 'search-controls' },
                            React.createElement(
                                'form',
                                { onSubmit: function onSubmit(e) {
                                        return e.preventDefault();
                                    } },
                                React.createElement('input', { onKeyDown: this.onEnter, onChange: this.setInputValue, id: 'find-search-input-text', type: 'search', className: 'search-bar',
                                    placeholder: !this.state.inputVal ? this.getLocalizedText('search_container_location_entry_placeholder') : '', ref: 'find_search_input_text', value: this.state.inputVal,
                                    'aria-label': !this.state.inputVal ? this.getLocalizedText('ada_find_search_text') : '', 'aria-autocomplete': 'list',
                                    title: this.getLocalizedText('search_container_search') }),
                                locationButton,
                                loadingSpinner,
                                React.createElement(
                                    'button',
                                    { id: 'find-search-input-submit', type: 'button', className: searchButtonClasses, 'aria-label': this.getLocalizedText('ada_find_search_enter'),
                                        onClick: this.props.searchIsLoading ? '' : this.handleSearchButtonClick },
                                    React.createElement('span', {
                                        className: 'glyphicon glyphicon-search' }),
                                    React.createElement(
                                        'span',
                                        { className: smallifyClass + " hidden-xs" },
                                        this.getLocalizedText('search_container_search')
                                    )
                                )
                            ),
                            suggestedLocationBox
                        ),
                        React.createElement(CheckboxContent, {
                            clearHandler: this.clearFilters,
                            currentFilters: this.state.filters,
                            checkboxHandler: this.checkboxHandler,
                            lang: this.props.lang,
                            cntry: this.props.cntry
                        })
                    ),
                    React.createElement(
                        'div',
                        { className: 'FPO' },
                        FPOContent
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'hidden-sm hidden-md hidden-lg hidden-xl' },
                    React.createElement(
                        'div',
                        { className: 'map-list-switcher' },
                        React.createElement(
                            'div',
                            { className: !listStyle ? 'list selected' : 'list', onClick: this.showList },
                            React.createElement('span', { className: 'glyphicon glyphicon-list' }),
                            this.getLocalizedText('search_container_list')
                        ),
                        React.createElement(
                            'div',
                            { className: !mapStyle ? 'map selected' : 'map', onClick: this.showMap },
                            React.createElement('span', { className: 'glyphicon glyphicon-globe' }),
                            this.getLocalizedText('search_container_map')
                        )
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'result-map-container' },
                    React.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-4 no-padding' },
                        React.createElement(
                            'div',
                            { 'aria-live': 'polite', 'aria-atomic': 'true' },
                            noLocationsElement
                        ),
                        React.createElement(
                            'div',
                            { className: "results-container" + listStyle + reducedHeightClass },
                            React.createElement('div', { className: '', id: 'is-screen-resolution-xs' }),
                            searchResults
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: mapStyle + " col-xs-12 col-sm-8 remove-right-padding" },
                        React.createElement(MapCanvas, {
                            googleMapsHelper: this.props.googleMapsHelper,
                            mapShowing: this.state.mapShowing,
                            isInModal: false,
                            refName: 'map_canvas',
                            locationSelectHandler: this.locationSelectHandler,
                            mapStyle: mapStyle,
                            mapLoaded: this.mapLoaded,
                            locations: locations,
                            handleMapLocationSelect: this.handleLocationSelect,
                            selectedLocationId: this.state.selectedLocationId,
                            locationSelectedWithEnter: this.state.locationSelectedWithEnter,
                            lang: this.props.lang,
                            cntry: this.props.cntry
                        }),
                        React.createElement(
                            'div',
                            { className: 'results-container col-xs-12 selected-result' },
                            selectedLocationElement
                        )
                    )
                )
            )
        );
    },

    onEnter: function handle(e) {
        if (e.keyCode === 13 && !this.props.searchIsLoading) {
            this.handleSearchButtonClick(e);
        } else if (e.keyCode === 40 && this.props.suggestedLocations && this.props.suggestedLocations.length > 0) {
            this.focusNextSuggestedLocation();
        }
    },

    focusNextSuggestedLocation: function focusNextSuggestedLocation() {
        if (!document.activeElement.className.match(/suggested-location-option/)) {
            document.querySelector('.suggested-location-option').focus();
        } else if (document.activeElement.nextSibling) {
            document.activeElement.nextSibling.focus();
        }
    },

    focusPreviousSuggestedLocation: function focusPreviousSuggestedLocation() {
        if (document.activeElement.previousSibling && document.activeElement.previousSibling.className.match(/suggested-location-option/)) {
            document.activeElement.previousSibling.focus();
        }
    },

    handleSuggestedLocationKeyDown: function handleSuggestedLocationKeyDown(e) {
        switch (e.keyCode) {
            case 13: // enter
            case 32:
                // space
                e.currentTarget.click();
                document.querySelector('#find-search-input-text').focus();
                break;
            case 38:
                // up arrow
                e.preventDefault();
                this.focusPreviousSuggestedLocation();
                break;
            case 40:
                //down arrow
                e.preventDefault();
                this.focusNextSuggestedLocation();
                break;
            default:
                break;
        }
    },

    handleLocationSelect: function handleLocationSelect(location, locationSelectedWithEnter) {
        var _this = this;

        var self = this;
        var locations = [location]; //turns location into array so mapCanvas can use it
        if (locationSelectedWithEnter && document.querySelector('.ada-map-focus-content') && this.state.selectedLocationId === location.id) {
            document.querySelector('.ada-map-focus-content').focus();
        }

        var callbackEvent = this.props.Actions.hasOwnProperty('setGlobalLocation') ? function () {
            _this.props.Actions.setGlobalLocation(location);
        } : function () {
            return true;
        };

        this.setState({
            selectedLocationId: location.id,
            locationSelectedWithEnter: locationSelectedWithEnter
        }, callbackEvent);

        if (document.getElementById('is-screen-resolution-xs')) {
            if (this.isMobileResolution() && !self.state.dontRenderModal) {
                this.props.Actions.showGenericModal(React.createElement(SelectedResultModal, _extends({}, self.props, {
                    locationSelectHandler: self.locationSelectHandler,
                    mapLoaded: self.mapLoaded,
                    locations: locations,
                    selectedLocationId: self.state.selectedLocationId,
                    lang: self.props.lang,
                    cntry: self.props.cntry,
                    key: location,
                    isFavorite: _.includes(self.props.favoriteLocationIds, location.id),
                    favoriteLocationClick: self.props.favoriteLocationClick,
                    selectedResult: true,
                    orderButtonClick: self.props.orderButtonClick,
                    buttonType: 'ordering', id: location.id,
                    location: location,
                    getLocalizedText: this.getLocalizedText,
                    notifyClick: self.props.notifyClick })), 'large');

                accessibilityHelper.focusOnElementAfterModalTransition('#find-description-modal', 'open');
            }
        }
    },

    showList: function showList() {
        this.setState({
            mapShowing: false,
            dontRenderModal: false
        });
    },

    showMap: function showMap() {
        this.setState({
            mapShowing: true,
            dontRenderModal: true
        });
    },

    searchContainerAnalytics: function searchContainerAnalytics(searchValue) {
        var filters = this.state.filters;
        this.props.Analytics.pushEvent(AnalyticsConstants.LOCATION_SEARCHED, this.props.Analytics.mergeParamsAndUserObj({
            Source: 'Order',
            Text: searchValue || 'Empty',
            Mobile_Ordering_Filter: filters.indexOf("hasMobileOrder") > -1 ? "Yes" : "No",
            Open_Late_Filter: filters.indexOf("isOpenLate") > -1 ? "Yes" : "No",
            Coca_Cola_Filter: filters.indexOf("hasCokeFreestyle") > -1 ? "Yes" : "No",
            Mobile_Payment_Filter: filters.indexOf("hasMobilePay") > -1 ? "Yes" : "No",
            Open_24_Hours_Filter: filters.indexOf("isOpen24Hours") > -1 ? "Yes" : "No",
            Favorites_Filter: filters.indexOf("isFavorite") > -1 ? "Yes" : "No",
            WiFi_Filter: filters.indexOf("hasWifi") > -1 ? "Yes" : "No",
            Breakfast_Filter: filters.indexOf("hasBreakfast") > -1 ? "Yes" : "No"
        }));
    },

    handleSearchButtonClick: function handleSearchButtonClick(val) {
        var _this2 = this;

        var searchValue = typeof val == 'string' ? val : this.refs.find_search_input_text.value;
        if (this.props.handleSearchButtonClick) {

            //whenever someone searches the filter should be set back to defaults
            this.setState({
                noMobileLocations: false,
                filters: this.props.initialFilters
            });

            this.searchContainerAnalytics(searchValue);
            this.props.handleSearchButtonClick(searchValue).then(function () {
                return _this2.handleSearchOnFilterChange();
            });
        }
        if (typeof val != 'string') {
            val.preventDefault();
        }
    },

    handleMyLocationClick: function handleMyLocationClick() {
        if (this.props.handleMyLocationClick) {
            this.props.handleMyLocationClick();
            this.setState({
                inputVal: ''
            });
        }
    },

    mapLoaded: function mapLoaded() {
        if (this.props.mapLoaded) {
            this.props.mapLoaded();
        }
    },

    isMobileResolution: function isMobileResolution() {
        if (document.getElementById('is-screen-resolution-xs')) {
            return window.getComputedStyle(document.getElementById('is-screen-resolution-xs')).fontWeight == 100;
        } else {
            return false;
        }
    },

    componentWillReceiveProps: function componentWillReceiveProps(next) {
        if (this.props.cntry && this.props.cntry !== next.cntry) {
            this.props.Actions.showLoadingSpinner();

            if (this.props.mapLoaded) {
                this.props.mapLoaded();
            } else {
                this.handleMyLocationClick();
            }
        }

        var locationsToReturn = this.getFilteredLocations(next.locations, next.favoriteLocationIds);

        //any time the page renders, it will check if there are locations but none showing because of the only filter active is mobile
        // and set the flag to show the no mobile locations element to true
        //can return blank filters array because we KNOW there is only hasMobileOrder given the checks
        if (next.locations.length && !locationsToReturn.length && this.state.noMobileLocations == false && this.state.filters.length == 1 && this.state.filters[0] == 'hasMobileOrder') {
            this.setState({
                noMobileLocations: true,
                filters: []
            });
        } else if (this.props.locations.length && !next.locations.length) {
            this.setState({
                noMobileLocations: false
            });
        }
    },

    componentDidUpdate: function componentDidUpdate(prevProps) {
        if (this.props.locations.length && !this.props.searchIsLoading && prevProps.searchIsLoading && !this.isMobileResolution()) {
            this.handleLocationSelect(this.props.locations[0]);
        }
        if (prevProps.lang != this.props.lang || prevProps.cntry != this.props.cntry) {
            //will only force a check if needed
            this.setState({
                url: this.determineStoreURL()
            });
        }
    },

    onSuggestionSelection: function onSuggestionSelection(suggestion) {
        //TODO wire it up to the container
        console.log(suggestion);
    }

});

module.exports = SearchContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/findLocationComponents/search/SearchContainer.js
// module id = 790
// module chunks = 0